/**
 * Registry der automatischen Aktionen, die eine E-Mail-Vorlage per ki_trigger
 * verwenden. EINE Vorlage pro Aktion (Zuordnung im Vorlagen-Tab); die Konsumenten:
 *  - handwerker_beauftragung  → TicketDetailSeite (autoVorlageTrigger)
 *  - rechnung_weiterleitung   → RechnungDetailsSidebar (autoVorlageTrigger)
 *  - nebenkosten_statusanfrage→ lib/aktionen/typen/antwortAbsender (KI-Antwortvorschlag)
 */
export interface VorlagenTrigger {
  key: string;
  label: string;
  beschreibung: string;
}

export const VORLAGEN_TRIGGER: VorlagenTrigger[] = [
  {
    key: 'handwerker_beauftragung',
    label: 'Handwerker beauftragen (Ticket)',
    beschreibung: 'Vorausgewählt beim Beauftragen aus einem Ticket — auftrag.*/meldender.*/objekt.*-Platzhalter kommen aus dem Ticket.',
  },
  {
    key: 'rechnung_weiterleitung',
    label: 'Rechnung an Eigentümer weiterleiten',
    beschreibung: 'Wird beim Weiterleiten einer Rechnung an den Eigentümer automatisch angewendet.',
  },
  {
    key: 'angebot_anfordern',
    label: 'Angebot anfordern (Ticket)',
    beschreibung: 'Angebotsanfrage an den Handwerker aus der KI-Aktion — auftrag.*/meldender.*/objekt.*-Platzhalter kommen aus dem Ticket.',
  },
  {
    key: 'antwort_absender',
    label: 'Antwort an Absender (Eingangsbestätigung)',
    beschreibung: 'Standard-Eingangsbestätigung der KI-Aktion „Antwort an Absender" ({{ticket.nummer}} verfügbar) — individuelle KI-Antwortvorschläge bleiben unberührt.',
  },
  {
    key: 'nebenkosten_statusanfrage',
    label: 'Nebenkosten-Statusanfrage (KI-Antwort)',
    beschreibung: 'KI-Antwortvorschlag auf Mieter-Anfragen zur Nebenkostenabrechnung.',
  },
  {
    key: 'termin_einladung',
    label: 'Termin-Einladung (Kalender)',
    beschreibung: 'Body der Outlook-Einladung an Termin-Teilnehmer (termin.*/objekt.*-Platzhalter). Der Mail-Betreff ist immer der Termin-Titel — das Betreff-Feld der Vorlage wird ignoriert.',
  },
  {
    key: 'termin_erinnerung',
    label: 'Termin-Erinnerung (24h/2h vorher)',
    beschreibung: 'Automatische Erinnerungs-Mail an Teilnehmer 24 Stunden und 2 Stunden vor dem Termin (termin.*/objekt.*-Platzhalter; Zusagen/Absagen-Buttons werden angehängt). Betreff wird automatisch gesetzt.',
  },
];

/** Deutsches Label zu einem ki_trigger; unbekannte Keys werden durchgereicht. */
export const triggerLabel = (key: string | null | undefined): string | null =>
  key ? (VORLAGEN_TRIGGER.find((t) => t.key === key)?.label ?? key) : null;
